import { Controller } from "stimulus"

export default class extends Controller {
  static values = { duration: Number }

  connect() {
    this.timeout = setTimeout(() => this.dismiss(), this.durationValue || 3000)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  dismiss() {
    this.element.style.opacity = "0"
    this.element.style.transition = "opacity 0.3s ease"
    setTimeout(() => this.element.remove(), 300)
  }
}
